<div provide-parent-form *ngIf="playout">

	<h3>{{ 'CONTROL_BAR' | translate }}</h3>
	<div *ngIf="playout && playout.controlBar">
		<bb-form-element [form]="form" [label]="'VISIBILITY' | translate" [helpMessage]="'HELP.CONTROLBAR_PLAYOUT_OPTIONS' | translate">
			<bb-select
				[(ngModel)]="playout.controlBar"
				name="playout-controlBar"
			>
				<option value="Autohide">{{ 'AUTO_HIDE_BUT_SHOW_ON_PAUSE' | translate }}</option>
				<option value="AlwaysAutohide">{{ 'ALWAYS_AUTO_HIDE' | translate }}</option>
				<option value="Show">{{ 'SHOW' | translate }}</option>
				<option value="Hide">{{ 'HIDE' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<!-- New setting for g8 -->
		<bb-form-element [form]="form" *ngIf="playoutService?.skinGeneration >= 8" [label]="'CONTROL_BAR_START_SCREEN' | translate">
			<bb-select
				name="playout-showStartControlBar"
				[(ngModel)]="playout.showStartControlBar"
			>
				<option value="Autohide">{{ 'AUTO_HIDE' | translate }}</option>
				<option value="Show">{{ 'SHOW' | translate }}</option>
				<option value="Hide">{{ 'HIDE' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'CONTROLBAR_PLACEMENT' | translate" [helpMessage]="'HELP.CONTROLBAR_PLACEMENT_OPTIONS' | translate">
			<bb-select [(ngModel)]="playout.controlBarPlacement" name="playout-controlBarPlacement">
				<option value="Auto">{{ 'AUTO' | translate }}</option>
				<option value="AlwaysMounted">{{ 'ALWAYS_MOUNTED' | translate }}</option>
				<option value="AlwaysFloating">{{ 'ALWAYS_FLOATING' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<!-- New setting for g8 -->
		<bb-form-element  *ngIf="playoutService?.skinGeneration >= 8" [form]="form" [label]="'STICKY_PROGRESS_BAR' | translate">
			<bb-select [(ngModel)]="playout.controlBarSticky" name="playout-controlBarSticky">
				<option value="Hide">{{ 'DONT_SHOW' | translate }}</option>
				<option value="Show">{{ 'SHOW_ON_HIDE' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<h3>{{ 'TIME' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'FORMATTING' | translate">
			<bb-select [(ngModel)]="playout.timeDisplay" name="playout-timeDisplay">
				<option value="Hide">{{ 'HIDE' | translate }}</option>
				<option value="Show remaining time">{{ 'SHOW_REMAINING_TIME' | translate }}</option>
				<option value="Show progress time">{{ 'SHOW_PROGRESS_TIME' | translate }}</option>
				<option value="Show progress and total time">{{ 'SHOW_PROGRESS_AND_TOTAL_TIME' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PROGRESS_BAR' | translate">
			<bb-check name="playout-timeLine" [(ngModel)]="playout.timeLine" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playout.timeLine !== 'Hide'" [form]="form" [label]="'DISABLE_FRAME_PREVIEW' | translate" [helpMessage]="'HELP.DISABLE_FRAME_PREVIEW' | translate">
			<bb-check name="playout-disableFramePreview" [(ngModel)]="playout.disableFramePreview" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
		</bb-form-element>
		
		<h3>{{ 'VOLUME' | translate }}</h3>
		
		<bb-form-element [form]="form" [label]="'VOLUME' | translate">
			<bb-select [(ngModel)]="volumeSetting" [ngModelOptions]="{standalone: true}" (ngModelChange)="volumeSettingChanged()">
				<option value="hide">{{ 'HIDE' | translate }}</option>
				<option value="mute_only">{{ 'MUTE_ONLY' | translate }}</option>
				<option value="horizontal_slider">{{ 'HORIZONTAL_SLIDER' | translate }}</option>
				<option *ngIf="playoutService?.skinGeneration <= 7" value="vertical_slider">{{ 'VERTICAL_SLIDER' | translate }}</option>
			</bb-select>
		</bb-form-element>


		<h3>{{ 'BUTTONS' | translate }}</h3>

		<bb-form-element [form]="form" [label]="(playoutService?.skinGeneration >= 8 ? 'SUBTITLE_TOGGLE_BUTTON' : 'SUBTITLE_SELECT') | translate" [helpMessage]="playoutService?.skinGeneration >= 8 ? '' : ('HELP.SUBTITLE_SELECT' | translate)">
			<bb-check name="playout-languageSelect" [(ngModel)]="playout.languageSelect" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'PLAYBACK_QUALITY_SELECTOR' | translate" [helpMessage]="'HELP.PLAYBACK_QUALITY_SELECTOR' | translate">
			<bb-check name="playout-qualitySelector" [(ngModel)]="playout.qualitySelector" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>
		

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'AUDIO_TRACK_SELECT' | translate" [helpMessage]="'HELP.AUDIO_TRACK_SELECT' | translate">
			<bb-check name="playout-audioTrackSelect" [(ngModel)]="playout.audioTrackSelect" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'PLAYBACK_RATE_SELECTOR' | translate" [helpMessage]="'HELP.PLAYBACK_RATE_SELECTOR' | translate">
			<bb-check name="playout-playbackRateSelector" [(ngModel)]="playout.playbackRateSelector" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'FULL_SCREEN_BUTTON' | translate" [helpMessage]="'HELP.FULL_SCREEN_BUTTON' | translate">
			<bb-check name="playout-fullScreen" [(ngModel)]="playout.fullScreen" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'SHARE_BUTTON' | translate" [helpMessage]="'HELP.SOCIAL_BUTTON' | translate">
			<bb-check name="playout-shareButton" [(ngModel)]="playout.shareButton" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'CAST_BUTTON' | translate" [helpMessage]="'HELP.CAST_BUTTON' | translate">
			<bb-check name="playout-castButton" [(ngModel)]="playout.castButton" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check>
		</bb-form-element>
	</div>
</div>
